<mat-toolbar>
  <mat-icon>filter_2</mat-icon>
  {{ controlName }}
</mat-toolbar>
<div class="hbox lightly-padded button-bar">
  <button mat-raised-button class="primary" (click)="updateValue()" [disabled]="!anyChanges(control, latest)">
    <mat-icon>add</mat-icon>
    Update
  </button>
</div>
<div class="padded">
  <table class="basicTable vtable">
    <tbody>
    <tr>
      <th>Type</th>
      <td>{{ control?.controlType }}</td>
    </tr>
    <tr>
      <th>{{ controlName }}</th>
      <td>
        <input [(ngModel)]="control.controlValue" [placeholder]="valuePlaceholder">
        <p *ngIf="valueNote" [innerHTML]="valueNote"></p>
      </td>
    </tr>
    <tr>
      <th>Description/Notice</th>
      <td>
        <textarea style="min-height: 10px"
                  [(ngModel)]="control.description"
                  [placeholder]="descriptionPlaceholder"
                  cols="50"
                  rows="5">
        </textarea>
        <p *ngIf="descriptionNote" [innerHTML]="descriptionNote"></p>
      </td>
    </tr>
    </tbody>
  </table>
</div>
<div [ngClass]="{'padded': false}">
  <table class="basicTable">
    <thead>
    <tr>
      <th>
        Date/Time
      </th>
      <th>
        {{controlName}}
      </th>
      <th>
        Description/Notice
      </th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let element of log">
      <td>
        {{ element.controlDate | dateTime }}
      </td>
      <td>
        {{ element.controlValue }}
      </td>
      <td>
        {{ element.description }}
      </td>
    </tr>
    <tr *ngIf="!log || log?.length === 0">
      <td colspan="100"><em>No results found</em></td>
    </tr>
    </tbody>
    <tfoot>
    <tr>
      <td colspan="100">
        <mat-paginator #paginator
                       (page)="reload()"
                       [pageSize]="100"
                       [pageSizeOptions]="[10, 25, 50, 100]">
        </mat-paginator>
      </td>
    </tr>
    </tfoot>
  </table>
</div>
